import Vue from 'vue';
import Router, { Route } from 'vue-router';
import VueI18n from 'vue-i18n';

Vue.use(Router);

/**
 * Extend the vue router to accept an i18n object as a constructor argument.
 * This makes it easy to get access to the current locale.
 */
class LocalizedRouter extends Router {

  private i18n: VueI18n;

  constructor(i18n: VueI18n) {
    super({
      mode: 'history',
      base: process.env.BASE_URL,
      routes: [
        {
          path: '/:lang/aps',
          name: 'aps-with-lang',
          component: () => import(/* webpackChunkName: "aps" */ './views/AuditoryPedestrianSignal.vue'),
          beforeEnter:  (to, from, next) => { this.detectLang(to, from, next); },
        },
        { path: '/aps', redirect: '/en/aps' },
        {
          path: '/:lang/poa',
          name: 'poa-with-lang',
          component: () => import(/* webpackChunkName: "poa" */ './views/POALookup.vue'),
          beforeEnter:  (to, from, next) => { this.detectLang(to, from, next); },
        },
        { path: '/poa', redirect: '/en/poa' },
        { path: '*', redirect: '/poa' },
      ],
    });

    this.i18n = i18n;
  }

  /**
   * This method invokes the router to navigate to the currently set locale.
   * It can be used after setting the locale to ensure the path reflects the
   * current value (eg. /en/poa or /fr/poa).
   */
  public switchLang() {
    if (this.currentRoute && this.currentRoute.name) {
      const newLang = this.i18n.locale;
      this.push({
        name: this.currentRoute.name,
        params: {
          lang: newLang,
        },
      });
    }
  }

  /**
   * This navigation guard (https://router.vuejs.org/guide/advanced/navigation-guards.html)
   * may be used to detect language as the first route segment, and to set the locale
   * accordingly.
   */
  private detectLang(to: Route, from: Route, next: any) {
    if (to && to.params && to.params.lang) {
      const lang = to.params.lang.toLowerCase() === 'fr' ? 'fr' : 'en';
      document.documentElement.lang = lang;
      this.i18n.locale = lang;
    }
    next();
  }
}

export default LocalizedRouter;
